const COOKIE_PREFIX = 'nl_sub_';
/** 24 hours — one successful signup per email hash. */
const MAX_AGE_SECONDS = 24 * 60 * 60;

function cookieName(emailHash: string): string {
  return `${COOKIE_PREFIX}${emailHash.slice(0, 32)}`;
}

export function hasRecentNewsletterSignup(emailHash: string): boolean {
  if (typeof document === 'undefined') return false;
  const name = cookieName(emailHash);
  return document.cookie.split(';').some((part) => part.trim().startsWith(`${name}=`));
}

export function markNewsletterSignup(emailHash: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${cookieName(emailHash)}=1;path=/;max-age=${MAX_AGE_SECONDS};SameSite=Lax`;
}
